
import i18n from "@/i18n";
import { createauthority, deleteAuthority, searchAuthority } from "@/store/services/configuration/AuthorityService";
import { AuthorityState } from "@/types";
import Notify from 'quasar/src/plugins/Notify.js';;
import { Module } from "vuex";


const AuthorityModule: Module<AuthorityState, any> = {
  namespaced: true,
  state: {
   
  },
  getters: {

  },
  actions: {
    searchAuthority({ commit }, payload) {
        const { filter,offset,limit, callback } = payload;
        searchAuthority(filter,offset,limit)
          .then((res) => {
            callback(res);
          })
          .catch((e) => console.error(e));
      },
      createauthority({ state, commit }, payload) {
        const { authority, callback} = payload
        createauthority(authority)
                .then((res:any) => {
                    Notify.create({
                        message: "Document type Created...",
                        color: "positive",
                    })
                    callback(res);
                })
                .catch((e:any) => console.error(e))
          },
          deleteAuthority({ commit }, payload) {
            const { resourceUid } = payload
            deleteAuthority(resourceUid)
                .then((res:any) => {
                    Notify.create({
                        message: i18n.global.t("order.messages.deleteSuccess"),
                        color: "positive",
                    })
                    
                })
                .catch((err:any) => {
                    console.error(err);
                    Notify.create({
                      message: err,
                      color: "negative",
                    });
                })
        },
  },
  mutations: {

  }
};
export default AuthorityModule;
